import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setRefreshToken, removeAuthToken } from '../../lib/auth';
import { GetMeResponse } from '../services/authService';

export interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  user: GetMeResponse | null;
}

const getInitialState = (): AuthState => {
  return {
    isAuthenticated: false,
    token: null,
    user: null,
  };
};

const initialState: AuthState = getInitialState();

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<GetMeResponse>) => {
      state.user = action.payload;
      if (action.payload) {
        state.isAuthenticated = true;
      }
    },
    setTokens: (
      state,
      action: PayloadAction<{ token: string; refreshToken?: string }>
    ) => {
      state.token = action.payload.token;
      state.isAuthenticated = true;
      if (action.payload.refreshToken) {
        setRefreshToken(action.payload.refreshToken);
      }
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;

      removeAuthToken();
    },
  },
});

export const { setTokens, logout, setUser } = authSlice.actions;
export default authSlice.reducer;
